import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import toast, {Toaster} from "react-hot-toast";

import styles from './MainPage.module.scss';
import OrdersList from "../../components/OrdersList/OrdersList";
import Promotions from "../../components/Promotions/Promotions";
import {promotionsService} from "../../services/promotions.service";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {userDetailsActions} from "../../store/slices/userDetailsSlice";
import {cleaningRequestsActions} from "../../store/slices/cleaningRequestsSlice";
import MainButtonTransparentBackground
    from "../../components/UI/MainButtonTransparentBackground/MainButtonTransparentBackground";
import isCustomer from "../../HOC/IsCustomer";

const MainPage = () => {
    const {state} = useLocation();

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    // Live promotions ("Акції") loaded from the API. The home layout reacts to
    // its length: 0 -> "Акції" hidden so "Ваші замовлення" fills the row,
    // 1 -> single full-width card, 2+ -> swiper slider.
    const [promotions, setPromotions] = useState([]);

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const {status, user} = useSelector(state => state.userDetails);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        const getUserById = async (id) => {
            await dispatch(userDetailsActions.getById({id}));
        }

        const getActiveCleaningRequestsByCurrentUser = async () => {
            try {
                await dispatch(cleaningRequestsActions.getActiveByCurrentUser());
            } catch (error) {
                console.error(error);
            }
        }

        const getHistoryCleaningRequestsByCurrentUser = async () => {
            try {
                await dispatch(cleaningRequestsActions.getHistoryByCurrentUser());
            } catch (error) {
                console.error(error);
            }
        }

        if (state?.id) {
            const {id} = state;
            getUserById(id);
        } else {
            const {id} = user;
            getUserById(id);
        }

        getActiveCleaningRequestsByCurrentUser();
        getHistoryCleaningRequestsByCurrentUser();
    }, [state]);

    const handleDeleteOrder = async (setIsModalDeleteOrderOpen, id) => {
        try {
            await dispatch(cleaningRequestsActions.deleteById({id}));
            setIsModalDeleteOrderOpen(false);

            //delete cleaning request from store
            dispatch(cleaningRequestsActions.deleteActiveCleaningRequestByCurrentUserById(id));

            toast.success(`Замовлення №${id} було успішно видалено!`, {id: "remove-request"});
        } catch (error) {
            console.error("Error deleting order:", error);
            toast.error(error?.message, {id: "remove-request"});
        }
    }

    const handleNavigate = (path) => {
        localStorage.setItem('currentStep', JSON.stringify(1));
        navigate(path);
    }

    useEffect(() => {
        const getPromotions = async () => {
            try {
                const {data} = await promotionsService.getAll();
                // The endpoint is paginated ({results: [...]}); fall back to a
                // bare array for safety.
                setPromotions(data?.results || data || []);
            } catch (error) {
                console.error(error);
            }
        }

        getPromotions();
    }, []);

    useEffect(() => {
        return () => {
            toast.remove("remove-request")
        }
    }, []);

    return (
        <div className={styles.mainPage}>
            <div className={styles.mainPage_wrapper}>
                <div className={styles.mainPage_wrapper_content}>
                    <div className={styles.mainPage_wrapper_content_titleContainer}>
                        <h1 className={styles.mainPage_wrapper_content_titleContainer_title}>
                            Вітаємо в Kova!</h1>

                        <MainButtonTransparentBackground
                            width={windowWidth > 425 ? 'auto' : '100%'}
                            type={'button'}
                            onClick={() => handleNavigate(MAIN_ROUTES.CREATE_ORDER)}
                            condition={false}
                            text={'Замовити прибирання'}
                        /></div>

                    <div className={styles.mainPage_wrapper_content_tables}>
                        <OrdersList handleDeleteOrder={handleDeleteOrder}/>
                        {/* No promotions -> hide "Акції" so "Ваші замовлення" fills the row. */}
                        {promotions.length > 0 && <Promotions promotions={promotions}/>}
                    </div>
                </div>

                {/* to appear hot toast notification */}
                <Toaster/>
            </div>
        </div>
    );
};

export default isCustomer(MainPage);
